/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IObjectSchemaScope extends ng.IScope {
        schema: Wars.Domain.Model.ObjectSchema;
        schemaToMapTo: Wars.Domain.Model.ObjectSchema;
        allowMapping: boolean;
        mappings: Wars.Domain.Model.SchemaMapping[];
        getMappingName: any;
        mappedPropertySelected: any;
        propertySelected: any;
        reload: boolean;
    }

    export class ObjectSchema implements IDirective {
        public link($scope: IObjectSchemaEditorScope, element: JQuery, attrs: ng.IAttributes, controller: ObjectSchemaController) { }
        public templateUrl = './app/views/directives/objectSchema.html';
        public restrict: string = 'E';
        public controller = ['$scope', 'objectSchemaService', ObjectSchemaController];
        public controllerAs = 'controller';
        public scope: any = {
            schema: "=",
            schemaToMapTo: "=",
            allowMapping: "=",
            mappings: "=",
            reload: "="
        };
        public compile = (element) => {
            return this.recursionHelper.compile(element);
        }

        private recursionHelper: any;

        constructor(recursionHelper: any) {
            this.recursionHelper = recursionHelper;
        }
    }


    export class ObjectSchemaController implements IController {

        constructor(private $scope: IObjectSchemaScope, private objectSchemaService: services.ObjectSchemaService) {
            $scope.propertySelected = {};
            $scope.getMappingName = (p) => this.getMappingName(p);
            $scope.mappedPropertySelected = (a) => this.mappedPropetrySelected(a);

            this.setSelectedProperties();

            $scope.$watch('reload', () => {
                this.setSelectedProperties();
            });
        }

        private setSelectedProperties() {
            if (this.$scope.schema) {
                this.$scope.schema.properties.forEach(prop => {
                    this.$scope.propertySelected[prop.id] = this.getMappedId(prop.id);
                });
                //console.log(this.$scope.propertySelected);
                this.$scope.reload = false;
            }
        }

        private getMappingName(property: warsApp.models.SchemaProperty) {
            let mapping = Enumerable.from(this.$scope.mappings).single(s => s.leftSchemaProperty_id == property.id);

            let mappedProperty = Enumerable.from(this.$scope.schemaToMapTo.properties).singleOrDefault(s => s.id == mapping.rightSchemaProperty_id);

            if (mappedProperty) {
                return mappedProperty.name;
            }

            return "";
        }

        private getMappedId(id: string) {
            let mapping = Enumerable.from(this.$scope.mappings).single(s => s.leftSchemaProperty_id == id);

            return mapping.rightSchemaProperty_id;
        }


        private mappedPropetrySelected(propertyId: string) {
            let mapping = Enumerable.from(this.$scope.mappings).single(s => s.leftSchemaProperty_id == propertyId);
            mapping.rightSchemaProperty_id = this.$scope.propertySelected[propertyId];
            this.objectSchemaService.saveAllChanges();
        }
    }
}

warsApp.registerDirective('ObjectSchema', ['recursionHelper']);